import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import AnimatedLoader from "@hl/base-components/lib/AnimatedLoader";
import { Center, ScrollArea, Stack, Text } from "@mantine/core";
import { useWatchlistAndFollowContext } from "../../WatchlistAndFollowContext";
import { useSuggestedFollowsQuery } from "../../queries.graphql.generated";
import { FollowerTile } from "./FollowerTile";
export const SuggestedTab = (_props) => {
    var _a;
    const suggestedFollowsQueryResult = useSuggestedFollowsQuery({
        variables: {
            limit: 100,
            cursor: null,
        },
    });
    const watchlistAndFollowContext = useWatchlistAndFollowContext();
    const { isFollowing, follow } = watchlistAndFollowContext;
    const suggestedFollows = (_a = suggestedFollowsQueryResult === null || suggestedFollowsQueryResult === void 0 ? void 0 : suggestedFollowsQueryResult.data) === null || _a === void 0 ? void 0 : _a.suggestedFollows.edges.map((edge) => edge.node).filter((node) => !isFollowing(node.address));
    const loading = suggestedFollowsQueryResult.loading || watchlistAndFollowContext.loading;
    const error = suggestedFollowsQueryResult.error || watchlistAndFollowContext.error;
    if (suggestedFollows == null && loading) {
        return (_jsx(Center, { mih: 400, mah: 400, children: _jsx(Stack, { align: "center", spacing: 0, children: _jsx(AnimatedLoader, { size: 72 }) }) }));
    }
    if (suggestedFollows == null || error != null) {
        return (_jsx(Center, { mih: 400, mah: 400, children: _jsx(Text, { c: "tertiaryText", children: "Something went wrong" }) }));
    }
    if (suggestedFollows.length === 0) {
        return (_jsx(Center, { mih: 400, mah: 400, children: _jsx(Text, { c: "tertiaryText", children: "No new suggestons right now" }) }));
    }
    return (_jsx(ScrollArea, { h: 400, mt: 16, offsetScrollbars: true, type: "auto", children: _jsx(Stack, { spacing: 0, align: "start", children: suggestedFollows.map((follower) => {
                var _a;
                const publicAccountSettings = follower.publicAccountSettings;
                const avatar = publicAccountSettings === null || publicAccountSettings === void 0 ? void 0 : publicAccountSettings.displayAvatar;
                const displayName = (_a = publicAccountSettings === null || publicAccountSettings === void 0 ? void 0 : publicAccountSettings.displayName) !== null && _a !== void 0 ? _a : publicAccountSettings === null || publicAccountSettings === void 0 ? void 0 : publicAccountSettings.wallet.ensName;
                const verified = !!(publicAccountSettings === null || publicAccountSettings === void 0 ? void 0 : publicAccountSettings.verified);
                const walletAddress = follower.address;
                const following = isFollowing(walletAddress);
                return (_jsx(FollowerTile, { walletAddress: walletAddress, displayName: displayName, avatarUrl: avatar, verified: verified, isFollowing: following, onFollowClick: () => {
                        follow(walletAddress, !following);
                    } }, walletAddress));
            }) }) }));
};
